module.exports = __webpack_public_path__ + "img/content2.0237ca65.png";